var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12968_23989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38322 0 0 5.38322 0 12C0 18.6168 5.38322 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38322 18.6168 0 12 0ZM12 22.1538C6.40116 22.1538 1.84617 17.5988 1.84617 12C1.84617 6.4012 6.40116 1.84617 12 1.84617C17.5988 1.84617 22.1538 6.40116 22.1538 12C22.1538 17.5988 17.5988 22.1538 12 22.1538Z",
    fill: "#F4F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2705 8.27051L10.1539 14.387L7.72964 11.9628L6.42432 13.2682L10.1539 16.9978L17.5758 9.57588L16.2705 8.27051Z",
    fill: "#F4F6FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12968_23989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck1);
export default __webpack_public_path__ + "static/media/check1.e5d447b24429308e2f61f13d11267f6b.svg";
export { ForwardRef as ReactComponent };